<template>
    <div class="message">
        <div class="title_msg">
            <img src="../../assets/lives/goback.png" alt="" @click="excitvcommodity">
            全部商品
            <div class="line_title">
            </div>
        </div>
        <div class="commodity_list">

            <div class="commodity_item" v-for="(item, index) in commodityList" :key="item.productId">
                <span class="orderIndex">{{ item.productCode }}</span>
                <div class="img">
                    <img :src="item.productSpuDTO.spuImage[0].imageUrl" alt="">
                    <span v-if="item.productRecommendStatus == 'recommendIng'" class="tj">推荐中</span>
                </div>
                <div>
                    <div>
                        {{ item.productSpuDTO.spuName }}
                    </div>
                    <div class="second_item">
                        <span>￥</span>
                        <span>{{ item.productSpuDTO.skuList[0].salePrice / 100 }}</span>
                        <span class="hx" v-if="item.productSpuDTO.oriPrice != 0">￥{{ item.productSpuDTO.oriPrice / 100
                        }}</span>
                        <span v-if="item.productSellOutStatus == 'unsellout'" @click="paycommodity(item)">{{
                            buyButtonText
                        }}</span>
                        <span class="sqbtn" v-if="item.productSellOutStatus == 'selloutIng'"
                            @click="paycommodity(item)">{{ productSoldOutDesc }}</span>
                        <!-- <a :href="gethttpdata(item.jumpAddress)" target="_blank" v-else><span
                                @click="escalation(item)">立即查看</span></a> -->
                    </div>
                    <div class="last_item">
                        <!-- <span>销量：{{item.orderNumber}}</span> -->
                    </div>
                </div>
            </div>


            <div v-if="commodityList.length == 0">暂无商品</div>
        </div>
        <div class="giftfk" v-if="paycode">
            <div>请用微信扫码支付</div>
            <fkcode :link="recommend_url"></fkcode>
            <!-- <br>
            <span style="color: red;">{{ count }}</span> 秒后自动取消 -->
            <br>
            <div style="color:#256EE7;" @click="cancelpay()">取消支付</div>
        </div>
        <div class="mb_giftfk" v-if="paycode">
        </div>
    </div>
</template>

<script>
import fkcode from './fkcode'
import { mapState } from 'vuex'
export default {
    name: 'commodity',
    components: {
        fkcode
    },
    props: {
        buyButtonText: {
            type: String,
            default: '立即抢购'
        },
        productSoldOutDesc: {
            type: String,
            default: '已售罄'
        },
        roomId: {
            type: Number | String,
            default: ''
        },
    },
    mounted() {
    },
    data() {
        return {
            list: [],
            paycode: false,
            orderinfo: {},
            count: 60,
            times: null,
            time: null
        }
    },
    computed: {
        ...mapState({
            commodityList: (state) => state.commodityList
        })
    },
    watch: {
        commodityList: {
            handler(val) {
                //没有数据
                if (val.length === 0) {
                    this.$emit("excitvcommodity", false)
                }
                else {
                    for (var i = 0; i < this.commodityList.length; i++) {
                        // console.log(this.commodityList[i]);
                    }
                }
            }
        }
    },
    methods: {
        excitvcommodity() {
            this.$emit("excitvcommodity", false)
        },
        isGreater(givenTimestamp) {
            // 获取当前时间戳
            let now = Date.now();
            // 计算20秒后的时间戳
            let twentySecondsLater = now + 5000;
            return givenTimestamp > twentySecondsLater;
        },
        // 获取商品列表
        getroomcommodityinfo() {
            this.$liveapi.getroomcommodity(1, 100).then(res => {
                let list = JSON.parse(JSON.stringify(res.data.data))
                this.$store.commit("updateCommodityList", list)
                // if (list.length > 0) {
         
                //     let index = list.findIndex(product => product.productRecommendStatus === 'recommendIng' && product.productSellOutStatus == 'unsellout');
                //     if (index != -1) {
                //         let exts = JSON.parse(list[index].exts)
                //         if ('timeOut' in exts) {
                //             list[index].endTime = exts.timeOut
                //         }
                //         list[index].sendTime = exts.sendTime
                //         if ('styleType' in exts) {
                //             list[index].styleType = exts.styleType
                //         } else {
                //             list[index].styleType = 1
                //         }
                //         if ("heat" in exts) {
                //             list[index].heat = exts.heat;
                //         }
                //         // 扩展字符
                //         if (('timeOut' in exts) && this.isGreater(exts.timeOut)) {
                //             this.$emit('recommend_dec', list[index])
                //         } else {
                //             this.$emit('recommend_dec', list[index])
                //         }
                //         console.log(list[index]);
                //         console.log('-----');
                        
                        
                //     }
                // }
            })
        },
        async paycommodity(item) {
            if (item.productSellOutStatus === 'selloutIng') {
                this.$message({ type: 'error', message: '商品已售罄' })
                return
            } else {
                this.$liveapi.productPV({
                    roomId: this.roomId,
                    productId: item.productId,
                    nickName: localStorage.getItem('user_name'),
                    customId: '',
                    customMobile: localStorage.getItem('user_phone'),
                    icon: localStorage.getItem('user_headimg'),
                    accountId: '',
                    whiteMobile: '',
                    dateTime: new Date().getTime()
                })
                this.recommend_url = window.location.href
                this.paycode = true
            }
            // let _this = this
            // let { data } = await this.$liveapi.generateOrder({
            //     "amount": item.productSpuDTO.skuList[0].salePrice,
            //     "channel": "LIVE",
            //     "customMobile": localStorage.getItem('user_phone'),
            //     "promotionCode": _this.$route.params.id,
            //     "deliverAddress": "910",
            //     "deliverCity": "静安区",
            //     "deliverProvince": "上海市",
            //     "deliverRegion": "市北",
            //     "deliverUserName": "SpiderMan",
            //     "orderTimeSection": "RELIVE",
            //     "orderName": "",
            //     "skuCount": 1,
            //     "productId": item.productId,
            //     "skuId": item.productSpuDTO.skuList[0].skuId,
            //     "token": ""
            // })
            // if (data.code === 0) {
            //     this.$liveapi.getwxorderconfig({

            //         "orderNo": data.data.orderNo,
            //         "payChannel": "WXPAY",
            //         "payType": "NATIVE",
            //         "token": ""
            //     }).then(res => {
            //         if (res.data.code === 0) {
            //             this.paycode = true
            //             this.orderinfo.url = res.data.data.codeUrl
            //         }
            //     })
            // }

            // var hobj = {
            //     id: val.commodityId,
            //     account: localStorage.getItem('user_account'),
            //     nickname: localStorage.getItem('user_name'),
            //     headUrl: localStorage.getItem('user_headimg'),
            //     userFrom: localStorage.getItem('login_qd'),
            //     clientFrom: '1',
            //     channelName: ''
            // }
            // if (localStorage.getItem('iswx') == 0 && localStorage.getItem('logtpye') == 4) {
            //     hobj.nickname = localStorage.getItem('user_name1')
            // }
            // this.$api.escalationCheck(hobj).then(res => { })
            // this.$api.createcommodity(val.commodityId, localStorage.getItem('user_account')).then(res => {
            //     this.paycode = true
            //     this.orderinfo = res.data.data
            //     this.times = setInterval(() => {
            //         this.wxcheckorder(res.data.data.orderNum);
            //     }, 2000);
            //     this.time = setInterval(() => {
            //         if (this.count <= 0) {
            //             clearInterval(this.time);
            //             clearInterval(this.times);
            //             this.count = 60;
            //             this.paycode = false
            //             return;
            //         }
            //         --this.count;
            //     }, 1000);
            // })
            // var obj = {
            //     commodityId: val.commodityId,
            //     account: localStorage.getItem('user_account'),
            //     commodity: val.commodity,
            //     img: val.img,
            //     commodityPrice: val.commodityPrice
            // }
            // // 数据上报
            // this.$api.addCommodityClick(obj).then(res => {
            // })
            // // 订单场控数据上报
            // var clicktime = new Date()
            // var orderObj = {
            //     id: val.commodityId,
            //     nickname: localStorage.getItem('user_name'),
            //     clientFrom: "1",
            //     headUrl: localStorage.getItem('user_headimg'),
            //     channelName: sessionStorage.getItem('channel_info') ? JSON.parse(sessionStorage.getItem('channel_info')).title : "",
            //     channelNo: sessionStorage.getItem('channel_info') ? JSON.parse(sessionStorage.getItem('channel_info')).channel_id : "",
            //     clickTime: clicktime.getTime(),
            //     clickNum: "1"
            // }
            // this.$api.addOrderControlRecord(orderObj).then(res => { })
        },
        //处理无请求头数据
        gethttpdata(val) {
            var tj = val
            if (tj.indexOf('http://') == -1 && tj.indexOf('https://') == -1) {
                tj = "https://" + tj
            }
            return tj
        },
        cancelpay() {
            this.count = 60;
            this.paycode = false
            clearInterval(this.time);
            clearInterval(this.times);
        },
        escalation(val) {
            var hobj = {
                id: val.commodityId,
                account: localStorage.getItem('user_account'),
                nickname: localStorage.getItem('user_name'),
                headUrl: localStorage.getItem('user_headimg'),
                userFrom: localStorage.getItem('login_qd'),
                clientFrom: '1',
                channelName: ''
            }
            if (localStorage.getItem('iswx') == 0 && localStorage.getItem('logtpye') == 4) {
                hobj.nickname = localStorage.getItem('user_name1')
            }
            this.$api.escalationCheck(hobj).then(res => { })
            this.$api.escalation(val.commodityId).then(res => {
            })
            var obj = {
                commodityId: val.commodityId,
                account: localStorage.getItem('user_account'),
                commodity: val.commodity,
                img: val.img,
                commodityPrice: val.commodityPrice
            }
            // 数据上报
            this.$api.addCommodityClick(obj).then(res => {
            })
            // 订单场控数据上报
            var clicktime = new Date()
            var orderObj = {
                id: val.commodityId,
                nickname: localStorage.getItem('user_name'),
                clientFrom: "1",
                headUrl: localStorage.getItem('user_headimg'),
                channelName: sessionStorage.getItem('channel_info') ? JSON.parse(sessionStorage.getItem('channel_info')).title : "",
                channelNo: sessionStorage.getItem('channel_info') ? JSON.parse(sessionStorage.getItem('channel_info')).channel_id : "",
                clickTime: clicktime.getTime(),
                clickNum: "1"
            }
            this.$api.addOrderControlRecord(orderObj).then(res => { })
        },
        wxcheckorder(val) {
            this.$api.wxcheckorder(val).then(res => {
                if (res.data.data.stats == 1) {
                    clearInterval(this.times);
                    clearInterval(this.time)
                    this.paycode = false
                    this.count = 60;
                    this.$message({
                        message: "支付成功",
                        type: "success"
                    });
                    setTimeout(() => {
                        this.$emit("excitvcommodity", false)
                    }, 1000);
                }
            })
        }
    },

}
</script>
<style scoped>
.message {
    position: relative;
    width: 100%;
    height: 100%;
    background: #FAFAFA;
    border-radius: 10px;
}

.title_msg {
    position: relative;
    padding-top: 18px;
    height: 6%;
    font-size: 16px;
    color: #256EE7;
    font-weight: 550;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
}

.title_msg img {
    position: absolute;
    left: 28px;
    width: 20px;
    height: 22px;
}

.line_title {
    width: 32px;
    height: 3px;
    margin: 4px auto;
    background-color: #256EE7;
    border-radius: 2px;
}

.commodity_list {
    height: 83%;
    width: 87%;
    padding: 24px;
    overflow-y: scroll;
}

.commodity_list::-webkit-scrollbar {
    width: 0px;
}

.commodity_item {
    position: relative;
    margin-bottom: 25px;
    border-bottom: 1px solid #ECECEC;
    height: 86px;
}



.orderIndex {
    position: absolute;
    left: 0px;
    width: 40px;
    height: 20px;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    font-size: 14px;
    border-radius: 10px;
    z-index: 10
}

.commodity_item .img {
    float: left;
    width: 70px;
    height: 70px;
    border-radius: 10px;
    margin-left: 0;
    position: relative;
}

.commodity_item .tj {
    position: absolute;
    z-index: 2;
    text-align: center;
    background: rgba(234, 69, 87, 0.85);
    width: 100%;
    color: white;
    padding: 6rpx 0;
    border-radius: 0 0 20rpx 20rpx;
    transform: translate(0, 120rpx);
    left: 0;
    bottom: 0;
    font-size: 12px;
}

.commodity_item .img img {
    width: 70px;
    height: 70px;
}

.commodity_item>div {
    text-align: left;
    float: left;
    width: 65%;
    margin-left: 16px;
}

.commodity_item>div div:first-child {
    width: 90%;
    height: 42px;
    font-size: 14px;
    font-weight: 550;
    line-height: 21px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.second_item span:first-child {
    font-size: 12px;
    color: #FF3434;
}

.second_item span:nth-child(2) {
    font-size: 14px;
    font-weight: 550;
    color: #FF3434;
}

.second_item .hx {
    font-size: 12px;
    margin-left: 15px;
    color: #999999;
    text-decoration: line-through;
}

.last_item span:first-child {
    float: left;
    font-size: 12px;
    margin-top: 8px;
    color: #4256FB;
}

.second_item span:last-child {
    display: block;
    float: right;
    font-size: 12px;
    width: 40%;
    height: 24px;
    text-align: center;
    line-height: 24px;
    background: #FCEDED;
    color: #FF3434;
    border-radius: 5px;
    border: 1px solid #FF3434;
    cursor: pointer;
}

.second_item .sqbtn {
    border: #666 !important;
    color: #fff !important;
    background: rgba(0, 0, 0, 0.6) !important;
}

.giftfk {
    background-color: #FFFFFF;
    padding: 50px;
    border-radius: 10px;
    height: 240px;
    width: 180px;
    position: fixed;
    z-index: 100;
    top: 30%;
    right: 45%;
}

.mb_giftfk {
    background-color: #000;
    opacity: 0.6;
    border-radius: 10px;
    position: fixed;
    z-index: 99;
    width: 100vw;
    height: 100vw;
    top: 0;
    right: 0;
}
</style>
